import React from "react";
import Page from "@jumbo/shared/Page";
import DemoRequestWizard from "app/pages/public/demo/DemoRequestWizard";
import OAuthAuthorize from "app/pages/oauth/OAuthAuthorize";

const publicRoutes = [
    {
        path: "/demo",
        element: <Page component={DemoRequestWizard} layout="solo-page" />
    },
    {
        // Autorización de OAuth (Claude.ai, ChatGPT): pública para poder pasar por el login y volver.
        path: "/oauth/authorize",
        element: <Page component={OAuthAuthorize} layout="solo-page" />
    },
];

export default publicRoutes;
